import { useEffect } from 'react';

import { Empty } from 'cpool-components/state/Empty';
import { useTranslation } from 'react-i18next';
import { LuMessageCircle } from 'react-icons/lu';

// Hidden E-Mails/Dateianhänge sub-tabs — restore: these imports, the state, the commented JSX blocks, SubTabs.tsx + its tests.
// import { useState } from 'react';
// import { COMMUNICATION_SUB_TABS, type CommunicationSubTab } from './constants';
// import { SubTabs } from './SubTabs';
import { ChatsListView } from '~/features/whatsapp/components/ChatPanel/ChatsListView';
import { ChatView } from '~/features/whatsapp/components/ChatPanel/ChatView';
import { UserInfoPanel } from '~/features/whatsapp/components/UserInfoPanel';
import { CHAT_LIST_VARIANTS } from '~/features/whatsapp/constants/chatListVariants';
import {
    CHAT_PANEL_VIEWS,
    closePanel,
    useChatPanelCurrentView,
    useChatPanelStore,
} from '~/features/whatsapp/stores/chatPanelStore';

// Renders the same ChatsListView (page variant)/ChatView/UserInfoPanel as ChatPanel, but inline in a 2-column layout.
export const CommunicationPage = () => {
    const { t } = useTranslation();
    // const [activeTab, setActiveTab] = useState<CommunicationSubTab>(COMMUNICATION_SUB_TABS.CHAT);
    const activeChatId = useChatPanelStore.use.activeChatId();
    const view = useChatPanelCurrentView();

    // Closes the floating ChatPanel if open — this page renders the same content inline.
    useEffect(() => {
        closePanel();
    }, []);

    return (
        <div className="flex flex-1 flex-col">
            {/* Title bar + sub-tabs, hidden while only the chat tab exists.
            <div className="flex items-center justify-between gap-4 border-b border-grey-outline-light bg-surface-light px-4 py-3 xl:px-8">
                <span className="text-lg font-semibold text-midnight">
                    {t('WHATSAPP_CHAT.COMMUNICATION_PAGE.TITLE')}
                </span>
                <SubTabs activeTab={activeTab} onChange={setActiveTab} />
            </div>

            {activeTab !== COMMUNICATION_SUB_TABS.CHAT && (
                <div className="flex flex-1 items-center justify-center">
                    <Empty title={t('WHATSAPP_CHAT.COMMUNICATION_PAGE.COMING_SOON')} />
                </div>
            )}
            */}
            {/* On restore: render the column box below only for activeTab === COMMUNICATION_SUB_TABS.CHAT. */}
            {/* Absolute fill bounds the columns' height, so their overflow-y-auto scrolls without a viewport calc. */}
            <div className="relative min-h-[420px] flex-1">
                <div className="absolute inset-0 flex gap-6 px-4 py-6 xl:px-8">
                    <div className="w-[36%] min-w-80 max-w-[493px] shrink-0 overflow-hidden rounded-md bg-surface-light">
                        <ChatsListView variant={CHAT_LIST_VARIANTS.PAGE} />
                    </div>
                    <div className="min-h-0 min-w-0 flex-1 overflow-hidden rounded-md border border-grey-outline-light bg-white">
                        {view === CHAT_PANEL_VIEWS.CHAT && activeChatId && <ChatView chatId={activeChatId} />}
                        {view === CHAT_PANEL_VIEWS.USER_INFO && activeChatId && <UserInfoPanel chatId={activeChatId} />}
                        {(view === CHAT_PANEL_VIEWS.LIST || !activeChatId) && (
                            <div className="flex h-full items-center justify-center">
                                <Empty
                                    icon={<LuMessageCircle />}
                                    title={t('WHATSAPP_CHAT.COMMUNICATION_PAGE.SELECT_CHAT_HINT')}
                                />
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};
